<template>
    <usual-alert
        :style="{
            background: '#FFFDF5',
            border: '1px solid #F9F1D0',
            color: '#52565C',
            padding: '10px 14px',
            marginTop: '10px',
            width: '100%',
            maxWidth: '400px',
            fontSize: '12px'
        }"
    >
        <template>
            <p class="warning">{{ t("expert.attention") }}</p>
            <p>{{ message }}</p>
        </template>
    </usual-alert>
</template>

<script>
import UsualAlert from "@components/Alerts/UsualAlert.vue"

export default {
    props: {
        message: {
            type: String,
            default: ""
        }
    },
    name: "PublicOfferPaymentError",
    components: { UsualAlert }
}
</script>

<style scoped lang="sass">

</style>
